<template>
  <div class="p-col-12 p-md-6 p-lg-4 card">
    <router-link
      style="text-decoration: none; color: inherit;"
      :to="route"
    >
      <Card style="margin: 0 1rem;">
        <template #header>
          <img
            :src="image"
            class="img-responsive"
          >
        </template>
        <template #title>
          {{ title }}
        </template>
        <template #subtitle>
          {{ subtitle }}
        </template>
        <template #content>
          {{ description }}
        </template>
      </Card>
    </router-link>
  </div>
</template>

<script>
import Card from 'primevue/card';

export default {
  components: { Card },
  props: {
    route: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>

.p-card {
  border: 0;
  box-shadow: 0 0.25rem 1rem rgba(48, 55, 66, 0.15);
}

.p-card:hover {
  cursor: pointer;
  background-color: #fafafa;
  box-shadow: 0 0.25rem 0.5rem rgba(48, 55, 66, 0.15);
}
</style>

<style lang="scss" scoped>
::v-deep(.p-card) {
    .p-card-title {
        color: #312b6c;
        font-size: 1.2rem;
    }
}
</style>
